module.exports = __webpack_public_path__ + "assets/img/guarantee1.0c24d6ae.png";